import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const selectWalletsState = createSelector(
  (state: RootState) => state.wallets,
  (walletsState) => walletsState
);

export const selectWalletsData = createSelector(
  selectWalletsState,
  (wallets) => wallets.data
);
